var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:'with-padding' + (_vm.value ? '' : ' disabled') + (_vm.displayAsIcon ? ' has-icon' : ''),attrs:{"href":_vm.value ? 'mailto:' + _vm.value : 'javascript:void(0)'}},[(_vm.displayAsIcon)?_c('a-icon',{attrs:{"type":"mail"}}):_c('span',{staticStyle:{"pointer-events":"none"},domProps:{"textContent":_vm._s(_vm.value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }